import { CarDetailsErrorCauses } from '../../_tools/errors/car-details';
import { CarListErrorCauses } from '../../_tools/errors/car-list';
import { ConfigErrorCauses } from '../../_tools/errors/config';
import { ErrorAction, Errors } from '../../_tools/types/function-output-type';
import { type TranslationsErrors } from './translations';

const deDE: TranslationsErrors = {
    actions: {
        [ErrorAction.NONE]: '',
        [ErrorAction.EXIT]: 'Fehler ausblenden',
        [ErrorAction.HOME]: 'Zurück zur Startseite',
        [ErrorAction.RELOAD]: 'Seite erneut laden',
    },
    default: {
        heading: 'Entschuldigung, es ist ein Fehler aufgetreten!',
        description: 'Bitte versuchen Sie es später erneut.',
    },
    [Errors.API]: {
        webcalc: {
            heading: 'WebCALC-Fehler',
            description: 'Leider ist bei der Abfrage der Kalkulationsdaten ein Fehler aufgetreten. Bitte versuchen Sie es später erneut!',
        },
    },
    [Errors.CAR_DETAILS]: {
        [CarDetailsErrorCauses.ERROR]: {
            heading: 'Fehler beim Abrufen der Fahrzeugdaten',
            description: '',
        },
        [CarDetailsErrorCauses.NOT_FOUND]: {
            heading: 'Fahrzeug nicht gefunden',
            description: '',
        },
    },
    [Errors.CAR_LIST]: {
        [CarDetailsErrorCauses.ERROR]: {
            heading: 'Fehler beim Abrufen der Fahrzeugliste',
            description: '',
        },
        [CarListErrorCauses.NO_RESULTS]: {
            heading: 'Keine Fahrzeuge gefunden',
            description: '',
        },
    },
    [Errors.CONFIG]: {
        [ConfigErrorCauses.DISABLED]: {
            heading: 'AHD Fleet deaktiviert',
            description: 'Sind Sie der Betreiber? Dann wenden Sie sich bitte an den Administrator.',
        },
        [ConfigErrorCauses.HOST_NOT_FOUND]: {
            heading: 'Der Host konnte nicht gefunden werden',
            description: 'Bitte informieren Sie den Kundensupport.',
        },
        [ConfigErrorCauses.MISSING_IDGROUP]: {
            heading: 'Feld "idGroup" fehlt in der Konfiguration',
            description: 'Bitte informieren Sie den Kundensupport.',
        },
        [ConfigErrorCauses.MISSING_LEADSYSTEM]: {
            heading: 'Feld "contactLeadSystem" fehlt in der Konfiguration',
            description: 'Bitte informieren Sie den Kundensupport.',
        },
        [ConfigErrorCauses.MISSING_LINKDISCLAIMER]: {
            heading: 'Feld "linkDisclaimer" fehlt in der Konfiguration',
            description: 'Bitte informieren Sie den Kundensupport.',
        },
        [ConfigErrorCauses.MISSING_MAIL]: {
            heading: 'Die Kontakt-E-Mail-Adresse ist nicht konfiguriert.',
            description: 'Bitte informieren Sie den Kundensupport.',
        },
    },
    [Errors.MODULE_DISABLED]: {
        heading: 'Entschuldigung, aber das Modul "{0}" steht derzeit nicht zur Verfügung!',
        description: 'Sind Sie der Betreiber? Dann wenden Sie sich bitte an den Administrator.',
    },
};

export default deDE;
